import { createFileRoute, useRouter } from '@tanstack/react-router'
import { WifiOff } from 'lucide-react'
import { useOnlineStatus } from '@/hooks/use-online-status'

/**
 * Écran de démarrage à froid sans réseau.
 * Le `navigateFallback` du service worker sert l'app shell précaché, ce qui
 * permet d'afficher cette page même au tout premier lancement hors connexion.
 */
export const Route = createFileRoute('/hors-connexion')({
  component: OfflineScreen,
})

function OfflineScreen() {
  const online = useOnlineStatus()
  const router = useRouter()

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-5 bg-navy-950 px-8 text-center pt-safe pb-safe">
      <div className="flex size-16 items-center justify-center rounded-[20px] border border-navy-800 bg-navy-900">
        <WifiOff size={28} color="#8A9BB0" aria-hidden="true" />
      </div>

      <div>
        <h1 className="text-[22px] font-bold text-chalk">Pas de connexion</h1>
        <p className="mt-2 text-[14px] leading-relaxed text-steel">
          Ekklesia a besoin d'Internet pour afficher vos données. Reconnectez-vous puis réessayez.
        </p>
      </div>

      <button
        type="button"
        onClick={() => router.navigate({ to: '/' })}
        disabled={!online}
        className="rounded-[14px] bg-gold px-6 py-3 text-[15px] font-semibold text-navy-950 disabled:opacity-40"
      >
        {online ? 'Réessayer' : 'En attente du réseau…'}
      </button>
    </div>
  )
}
